var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// en
import enAgencyProfile from './languages/en/agencyProfile.json';
import enAgencyUserDetails from './languages/en/agencyUserDetails.json';
import enConsolidFeeModule from './languages/en/consolidFeeModule.json';
import enLogin from './languages/en/login.json';
export var messages = {
    en: {
        translation: __assign(__assign(__assign(__assign({}, enAgencyProfile), enLogin), enAgencyUserDetails), enConsolidFeeModule),
    },
};
